import React, { useState } from 'react';
import { Box } from '@mui/material';
import Sidebar from './SideBar';
import AppBar from './AppBar';
import { useLanguage } from '../context/LanguageContext';

export const SIDEBAR_WIDTH = 240;
export const SIDEBAR_COLLAPSED_WIDTH = 64;

const Layout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { dir } = useLanguage();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Box
      dir={dir}
      style={{ direction: dir }}
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'background.default',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      {/* Sidebar Component */}
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isCollapsed={isCollapsed}
      />

      {/* Main Content Area */}
      <Box
        component="main"
        dir={dir}
        style={{ direction: dir }}
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      >
        <AppBar
          handleDrawerToggle={handleDrawerToggle}
          toggleCollapse={toggleCollapse}
          isCollapsed={isCollapsed}
        />

        <Box
          dir={dir}
          style={{ direction: dir }}
          sx={{
            flexGrow: 1,
            p: { xs: 1.5, sm: 2.5 },
            maxWidth: '1600px',
            width: '100%',
            mx: 'auto',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
